import React from "react";
import "./ControlsSwitch.css";

const ControlsSwitch = ({
  toggle = false,
  labelOn,
  labelOff,
  onChange
}) => {
  return (
    <>
      <label className="control-label">{toggle? labelOn : labelOff}</label>
      <label className="switch-wrapper">
        <input
          type="checkbox"
          checked={toggle}
          onChange={onChange}
        />
        <span className="slider"></span>
      </label>
    </>
  );
}

export { ControlsSwitch }
